import axios from "axios";

const getNumeroComprobante = async idTalonario => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    idTalonario: idTalonario,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };

  console.log(userData);
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Facturacion/GetNuevoNumeroComprobante`, userData);
    return response;
  } catch (error) {
    throw error;
  }
};

const numeroComprobante = {
  getNumeroComprobante,
};

export default numeroComprobante;
